import React, { useState, useEffect, useRef } from 'react';

export default function useTimer(callbackTicker, callbackTimeOver, seconds) {
  // initialize timeLeft with the seconds prop
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    // exit early + run callback when we reach 0
    if (!timeLeft) {
      callbackTimeOver();
      return;
    }

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
      callbackTicker(timeLeft - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [timeLeft]);

  useEffect(() => {
    setTimeLeft(seconds);
  }, [seconds]);

  return [timeLeft, setTimeLeft];
}
